import { useSelector } from 'react-redux';
import { getIpLatitude, getIpLongitude } from '../redux/geographic_location';

export const useGeographicLocation = () => {
  const ipLatitude = useSelector(getIpLatitude);
  const ipLongitude = useSelector(getIpLongitude);

  return {
    ipLatitude,
    ipLongitude,
  };
};
